export default __webpack_public_path__ + "static/media/reviews.9cdb5db2.svg";